import { styled } from 'twin.macro';

import { motion } from '@sopranodesign/framer-motion';

const ConnectionLine = styled(motion.path)`
  stroke: ${props => props.theme.primary};
  stroke-width: 2px;
`;

export default ConnectionLine;
